module.exports = __webpack_public_path__ + "img/logo.63ce7345.png";